/* src/App.js   */
import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { auth, db } from './apiClient';
import './index.css'; 

// --- Components ---
import LandingPage from './pages/LandingPage'; // <--- FIXED PATH
import Dashboard from './features/5DD/Dashboard';
																									 
import GlobalTimer from './components/GlobalTimer';
import Terms from './pages/terms';
import Privacy from './pages/privacy';

// --- NEW PAGES ---
import About5DD from './pages/About5DD';
import FiveBreaths from './features/FiveBreaths/FiveBreaths';

function App() {
  const [session, setSession] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Hook to check current route
  const location = useLocation();

  useEffect(() => {
							  
    auth.getSession().then(session => {
      setSession(session);
      if (session?.user?.id) {
        fetchProfile();
      } else {
        setLoading(false);
      }
    });

    const { data: { subscription } } = auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (session?.user?.id) {
        fetchProfile();
      } else {
        setProfile(null);
        setLoading(false);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const fetchProfile = async () => {
    try {
      const data = await db.profiles.me();
      if (data) setProfile(data);
    } catch (err) {
      console.error('Profile fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{color:'#fff', padding:'20px'}}>Loading...</div>;
  }

  // LOGIC: Hide Timer ONLY on the 5 Breaths page
  const showTimer = location.pathname !== '/five-breaths';

  return (
	   
    <div className="App">
      {/* GLOBAL TIMER: Conditionally Rendered */}
      {showTimer && <GlobalTimer profile={profile} />}
      
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
  
						
																	
        
        {/* NEW INFO PAGES */}
        <Route path="/about-5dd" element={<About5DD />} />
        <Route path="/five-breaths" element={<FiveBreaths session={session} />} />

        {/* ROOT + /home — Always show LandingPage regardless of login state */}
        <Route path="/" element={<LandingPage session={session} profile={profile} />} />
        <Route path="/home" element={<LandingPage session={session} profile={profile} />} />

        {/* DASHBOARD — 5DD app (requires login) */}
        <Route
            path="/dashboard"
            element={
                session ? (
                    <Dashboard session={session} profile={profile} />
                ) : (
                    <Navigate to="/" />
                )
            }
        />

        {/* CATCH ALL */}
        <Route path="*" element={<Navigate to="/" />} />
  
      </Routes>
    </div>
  );
}

export default App;
